<template>
    <v-container>
        <div class="section-listGame__header paddingTOP40">
            <div class="title">
                <div class="title__text">
                    <h2>{{ $t('front.search.titles.results') }}</h2>
                    <p>{{ $t('front.search.titles.results') }}</p>
                </div>
            </div>
        </div>

        <catalog-bar-with-provider-filter :sort-options="sortOptions" :vendor-platform-ids="vendorPlatformIds"
                   @sortOptionChanged="sortGames" @platformFilterChanged="filterGames"/>

        <div>
            <component :is="component" :items="getComponentItems(index)"
                       v-for="(component, index) in cycleComponents"
                       :key="index"></component>

            <div class="btn-loadCatalog" @click="showMoreGames" v-if="hasMoreGames">
                <span>{{ $t('front.search.button.load_more') }}</span>
            </div>
        </div>

        <div v-if="!loading && !sortedCategoryGames.length" class="text-center mt-5 mb-4">
            <h3>{{ $t('front.game.info.no_one_game_found') }}</h3>
        </div>
    </v-container>
</template>

<script>
import apiData from "../../../../mixins/apiData";
import SearchGame from "../../../../mixins/searchGame";
import sortGame from "../../../../mixins/sortGame";
import {searchGameSortOptions} from "../../../../interfaces/sortGameInterface";

export default {
    name: "SearchResults",

    mixins: [apiData, SearchGame, sortGame],

    metaInfo() {
        return  {
            title: this.$t('front.search.titles.results'),
        };
    },

    data: function () {
        return {
            innerWidth: undefined,
            isLgAndUp: false,
            cycleComponents: [
                'GamesBlockWithBigLeftItem',
                'GamesBlockWithBigRightItem',
            ],
            sortedOptionValue: undefined,
            sortOptions: this.getSortOptions(searchGameSortOptions),
        };
    },

    serverPrefetch() {
        this.searchText = this.$route.query.text && this.$route.query.text.toLowerCase() || null;

        return this.fetchSearchResultsPageGames(this.startGamesCount);
    },

    mounted() {
        this.$store.commit('CLOSE_SEARCH_DIALOG');

        this.searchText = this.$route.query.text && this.$route.query.text.toLowerCase() || null;

        this.defineScreenWidth();
        window.addEventListener('resize', this.defineScreenWidth);

        return this.fetchSearchResultsPageGames(this.startGamesCount, true);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.defineScreenWidth);
    },

    computed: {
        locale() {
            return this.$store.state.locale;
        },

        cycleComponentGamesCount() {
            // for server side
            if (!this.innerWidth){
                return 7;
            }

            if (this.innerWidth > 1024) {
                return 7;
            } else if (this.innerWidth > 767) {
                return 4;
            } else if (this.innerWidth > 600) {
                return 3;
            } else {
                return 2;
            }
        },

        startGamesCount(){
            return this.cycleComponentGamesCount * 2;
        },

        loadMoreGamesCount(){
            return (this.cycleComponents.length + 2) * this.cycleComponentGamesCount - this.searchGames.length;
        },

        sortedCategoryGames() {
            if (this.sortedOptionValue) {
                return this.sortGamesBySortOption(this.searchGames, this.sortedOptionValue);
            } else {
                return this.searchGames;
            }
        },
    },

    methods: {
        getComponentItems(LoopIndex) {
            let startItem = LoopIndex * this.cycleComponentGamesCount;
            let endItem = (LoopIndex + 1) * this.cycleComponentGamesCount;

            return this.sortedCategoryGames.slice(startItem, endItem);
        },

        showMoreGames() {
            if (this.loadMoreGamesCount > 0){
                this.fetchSearchResultsPageMoreGames(this.loadMoreGamesCount)
                .then(() => this.cycleComponents.push('GamesBlockWithBigLeftItem', 'GamesBlockWithBigRightItem'));
            }else {
                this.cycleComponents.push('GamesBlockWithBigLeftItem', 'GamesBlockWithBigRightItem');
            }
        },

        sortGames(sortOptionValue) {
            this.sortedOptionValue = sortOptionValue;
        },

        filterGames(filteredPlatformIds) {
            this.filteredPlatformIds = filteredPlatformIds;
            this.cycleComponents = this.cycleComponents.slice(0, 2);

            this.fetchSearchGames(false, false, true, this.startGamesCount);
        },

        defineScreenWidth() {
            this.innerWidth = window.innerWidth;
            this.isLgAndUp = window.innerWidth >= 1264;
        },
    },
}
</script>

<style lang="sass" scoped>
@import "sass/components/pages/parts/target/SearchResults"
</style>
